export default function isApp() {
  return !!navigator.userAgent.match(/bybit_app/i);
}

function isIPad(userAgent: string) {
  return (
    /iPad/i.test(userAgent) ||
    (/Macintosh/i.test(userAgent) && 'ontouchend' in window)
  );
}

const mobileRE =
  /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;

const tabletRE = /android|ipad|playbook|silk/i;
interface IsMobileOptions {
  ua?: any;
  tablet?: boolean;
  featureDetect?: boolean;
}
export function isMobile(opts?: IsMobileOptions) {
  if (!opts) opts = {};
  let ua = opts.ua;
  if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent;
  if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
    ua = ua.headers['user-agent'];
  }
  if (typeof ua !== 'string') return false;

  let result =
    mobileRE.test(ua) || (!!opts.tablet && (tabletRE.test(ua) || isIPad(ua)));

  if (
    !result &&
    opts.tablet &&
    opts.featureDetect &&
    navigator &&
    navigator.maxTouchPoints > 1 &&
    ua.indexOf('Macintosh') !== -1 &&
    ua.indexOf('Safari') !== -1
  ) {
    result = true;
  }

  return result;
}
export const jumpMePage = (language = 'en', isNewUser = false) => {
  if (isMobile()) {
    const downloadUrl: string = isNewUser
      ? `/${language}/download/?newUser=true`
      : `/${language}/download`;
    window.location.replace(downloadUrl);
  } else {
    const mePageUrl: string = isNewUser
      ? `/${language}/dashboard/?newUser=true`
      : `/${language}/dashboard`;
    window.location.replace(mePageUrl);
  }
};
